"use client"

import { useState } from "react"

const GenericItemForm = ({ onSubmit, onCancel, itemType }) => {
  const [formData, setFormData] = useState({
    item_name: "",
    description: "",
    quantity: 1,
    cost_price: 0,
    selling_price: 0,
    margin: 0,
    item_type: itemType,
    // Generic fields
    service_details: "",
    duration: "",
    location: "",
    date_required: "",
  })

  const getItemTypeLabel = (type) => {
    const labels = {
      baggage: "Baggage Service",
      visa_message: "Visa Message",
      ticketing: "Ticketing Service",
      real_estate: "Real Estate Service",
      visa_assistance: "Visa Assistance",
      attractions: "Attractions & Tours",
      umrah_service: "Umrah Service",
      b2b_khasab: "B2B Khasab Tour",
      security_deposit: "Security Deposit",
      typing_service: "Typing Service",
      burj_khalifa: "Burj Khalifa Tour",
      desert_safari: "Desert Safari",
      seat_pre_book: "Seat Pre-booking",
      food: "Food Service",
      others: "Other Service",
    }
    return labels[type] || type
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => {
      const updated = { ...prev, [name]: value }

      // Auto-calculate margin and total when prices change
      if (name === "cost_price" || name === "selling_price") {
        const costPrice = Number.parseFloat(name === "cost_price" ? value : updated.cost_price) || 0
        const sellingPrice = Number.parseFloat(name === "selling_price" ? value : updated.selling_price) || 0

        if (costPrice > 0) {
          updated.margin = Math.round(((sellingPrice - costPrice) / costPrice) * 100)
        }
        updated.total_amount = sellingPrice * updated.quantity
      }

      if (name === "quantity") {
        updated.total_amount = updated.selling_price * Number.parseInt(value)
      }

      return updated
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(formData)
  }

  return (
    <form onSubmit={handleSubmit} className="item-form">
      <div className="form-grid">
        <div className="form-group">
          <label>Item Name *</label>
          <input
            type="text"
            name="item_name"
            value={formData.item_name}
            onChange={handleInputChange}
            placeholder={`e.g., ${getItemTypeLabel(itemType)}`}
            required
          />
        </div>

        <div className="form-group">
          <label>Service Details</label>
          <input
            type="text"
            name="service_details"
            value={formData.service_details}
            onChange={handleInputChange}
            placeholder="Brief details about the service"
          />
        </div>

        <div className="form-group">
          <label>Location</label>
          <input
            type="text"
            name="location"
            value={formData.location}
            onChange={handleInputChange}
            placeholder="Service location (if applicable)"
          />
        </div>

        <div className="form-group">
          <label>Duration</label>
          <input
            type="text"
            name="duration"
            value={formData.duration}
            onChange={handleInputChange}
            placeholder="e.g., 2 hours, 1 day"
          />
        </div>

        <div className="form-group">
          <label>Date Required</label>
          <input type="date" name="date_required" value={formData.date_required} onChange={handleInputChange} />
        </div>

        <div className="form-group">
          <label>Quantity *</label>
          <input
            type="number"
            name="quantity"
            value={formData.quantity}
            onChange={handleInputChange}
            min="1"
            required
          />
        </div>

        <div className="form-group">
          <label>Cost Price *</label>
          <input
            type="number"
            name="cost_price"
            value={formData.cost_price}
            onChange={handleInputChange}
            step="0.01"
            min="0"
            required
          />
        </div>

        <div className="form-group">
          <label>Selling Price *</label>
          <input
            type="number"
            name="selling_price"
            value={formData.selling_price}
            onChange={handleInputChange}
            step="0.01"
            min="0"
            required
          />
        </div>
      </div>

      <div className="form-group full-width">
        <label>Description</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleInputChange}
          placeholder="Additional details about the service..."
          rows="3"
        />
      </div>

      <div className="pricing-summary">
        <div className="summary-item">
          <span>Margin: {formData.margin}%</span>
        </div>
        <div className="summary-item">
          <span>Total Amount: ${(formData.selling_price * formData.quantity).toFixed(2)}</span>
        </div>
      </div>

      <div className="form-actions">
        <button type="button" className="btn-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="btn-primary">
          Add {getItemTypeLabel(itemType)}
        </button>
      </div>
    </form>
  )
}

export default GenericItemForm
